import parse from "url-parse";
import axios from "axios";

export default {
  VERSION_FILE: "version.html",
  currentVersion() {
    // eslint-disable-next-line no-undef
    return BUILD_VERSION.substring(0, 10);
  },
  async lastVersion() {
    return axios
      .get(this.VERSION_FILE + "?" + Date.now())
      .then((res) => res.data.substring(0, 10));
  },
  checkVersionUpdate() {
    this.lastVersion()
      .then((version) => {
        if (version != this.currentVersion()) {
          this.refreshPage(version);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  },
  refreshPage(version) {
    let q = parse(location.href, true);
    q.query.ver = version;
    let url = q.toString();
    if (location.href != url) {
      location.href = url;
    }
  },
};
